module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-onigiri-e755d17b19d61fc325c39e0bd0ad9c89.png";